import { render, staticRenderFns } from "./EntityViewsDropdown.vue?vue&type=template&id=497bf698&scoped=true"
import script from "./EntityViewsDropdown.vue?vue&type=script&lang=js"
export * from "./EntityViewsDropdown.vue?vue&type=script&lang=js"
import style0 from "./EntityViewsDropdown.vue?vue&type=style&index=0&id=497bf698&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bf698",
  null
  
)

export default component.exports